/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Calm_Tuna_ExpandInputs */

const fr_full_calm_tuna_expand = /** @type {(inputs: Full_Calm_Tuna_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine`)
};

/**

* @param {Full_Calm_Tuna_ExpandInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const full_calm_tuna_expand = /** @type {((inputs?: Full_Calm_Tuna_ExpandInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Calm_Tuna_ExpandInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_full_calm_tuna_expand(inputs)
});